import { Layout, Tag, Text } from '@loadsmart/miranda-react'

import { type Stop } from 'core/domain/Stop'
import { type StopType } from 'core/domain/StopType'
import { getStopDescription } from 'core/presenters/stopPresenter'

import { TimelineItem } from '../timeline/TimelineItem'

export type StopTimelineItemProps = {
  children?: JSX.Element
  stopType: StopType
  stop: Stop
  stopLabel: string
}

export function StopTimelineItem({ stopType, children, stop, stopLabel }: StopTimelineItemProps) {
  return (
    <TimelineItem type={stopType}>
      <Layout.Stack gap="spacing-0-5">
        <Tag size="small">{stopLabel}</Tag>
        <Text variant="heading-sm-bold">{getStopDescription(stop)}</Text>
        {stop.zipCode && <Text variant="body-sm">{`ZIP ${stop.zipCode}`}</Text>}
        {children}
      </Layout.Stack>
    </TimelineItem>
  )
}
